/**
 * Normalize search input: lowercase, trim, collapse repeated whitespace.
 * Must stay aligned with SQL: regexp_replace(trim(lower(...)), '\s+', ' ', 'g')
 *
 * Used by matchesProspectFilter, usePaginatedProspects RPC, and
 * useServerAnalytics RPC to keep client-side and server-side search
 * behavior identical.
 */
export function normalizeSearchQuery(query: string | undefined | null): string {
  return (query || '').toLowerCase().trim().replace(/\s+/g, ' ');
}
